import { render, staticRenderFns } from "./ImportacionesFilter.vue?vue&type=template&id=8cf0f3ba"
import script from "./ImportacionesFilter.vue?vue&type=script&lang=js"
export * from "./ImportacionesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports